import { render, staticRenderFns } from "./FpSpinner.vue?vue&type=template&id=12fd2b78&lang=pug&"
import script from "./FpSpinner.vue?vue&type=script&lang=js&"
export * from "./FpSpinner.vue?vue&type=script&lang=js&"
import style0 from "./FpSpinner.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports